var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCareer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/briefcase"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/briefcase_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.09 6.98002C20.24 6.04002 18.82 5.57002 16.76 5.57002H16.52V5.53002C16.52 3.85002 16.52 1.77002 12.76 1.77002H11.24C7.48004 1.77002 7.48004 3.86002 7.48004 5.53002V5.58002H7.24004C5.17004 5.58002 3.76004 6.05002 2.91004 6.99002C1.92004 8.09002 1.95004 9.57002 2.05004 10.58L2.06004 10.65L2.13749 11.4633C2.15176 11.6131 2.23242 11.7484 2.35831 11.8307C2.59812 11.9877 2.99946 12.2464 3.24004 12.38C3.38004 12.47 3.53004 12.55 3.68004 12.63C5.39004 13.57 7.27004 14.2 9.18004 14.51C9.27004 15.45 9.68004 16.55 11.87 16.55C14.06 16.55 14.49 15.46 14.56 14.49C16.6 14.16 18.57 13.45 20.35 12.41C20.41 12.38 20.45 12.35 20.5 12.32C20.8968 12.0958 21.3083 11.8195 21.6835 11.5489C21.7965 11.4673 21.8688 11.3413 21.8842 11.2028L21.9 11.06L21.95 10.59C21.96 10.53 21.96 10.48 21.97 10.41C22.05 9.40002 22.03 8.02002 21.09 6.98002ZM13.09 13.83C13.09 14.89 13.09 15.05 11.86 15.05C10.63 15.05 10.63 14.86 10.63 13.84V12.58H13.09V13.83ZM8.91004 5.57002V5.53002C8.91004 3.83002 8.91004 3.20002 11.24 3.20002H12.76C15.09 3.20002 15.09 3.84002 15.09 5.53002V5.58002H8.91004V5.57002Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.8733 13.7341C21.2269 13.5659 21.6342 13.8462 21.5988 14.2361L21.2398 18.19C21.0298 20.19 20.2098 22.23 15.8098 22.23H8.18984C3.78984 22.23 2.96984 20.19 2.75984 18.2L2.41913 14.4521C2.38409 14.0667 2.78205 13.7867 3.13468 13.9463C4.2741 14.4618 6.37724 15.3764 7.67641 15.7166C7.84072 15.7597 7.97361 15.8773 8.04556 16.0311C8.65253 17.3292 9.96896 18.02 11.8698 18.02C13.752 18.02 15.085 17.3026 15.694 16.0013C15.766 15.8474 15.8991 15.7298 16.0635 15.6865C17.443 15.3235 19.6816 14.3012 20.8733 13.7341Z",
    fill: "#A8A8A8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareer);
export default __webpack_public_path__ + "static/media/career.e29fc954e8929dedf808bcb7777042ff.svg";
export { ForwardRef as ReactComponent };